(function mdvAccessibilityCompatibilityLayer() {
  'use strict';

  var KEYBOARD_NAVIGATION_KEYS = ['Tab', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Escape', 'Enter', ' '];

  function isTextEntryField(element) {
    if (!element || !element.tagName) return false;
    if (element.isContentEditable) return true;
    if (element.tagName === 'TEXTAREA' || element.tagName === 'SELECT') return true;
    if (element.tagName !== 'INPUT') return false;
    return !/^(button|submit|reset|checkbox|radio|range|file|color|image|hidden)$/i.test(element.type || 'text');
  }

  function setKeyboardModality(active) {
    document.documentElement.classList.toggle('mdv-kbd', active);
  }

  window.addEventListener('keydown', function trackKeyboardModality(event) {
    if (event.key === 'Tab') { setKeyboardModality(true); return; }
    if (KEYBOARD_NAVIGATION_KEYS.indexOf(event.key) === -1 || isTextEntryField(event.target)) return;
    setKeyboardModality(true);
  }, true);

  ['pointerdown', 'mousedown', 'touchstart'].forEach(function trackPointerModality(type) {
    document.addEventListener(type, function clearKeyboardModality() {
      setKeyboardModality(false);
    }, { capture: true, passive: true });
  });
  document.documentElement.classList.add('mdv-modality-ready');


  var filterDialogOpen = false;
  var filterOpener = null;
  var inertedElements = [];
  var miniCartOpen = false;
  var miniCartOpener = null;
  var miniCartInertedElements = [];
  var mobileMenuOpen = false;
  var mobileMenuOpener = null;
  var mobileMenuInertedElements = [];
  var wishlistPopupOpen = null;
  var wishlistPopupOpener = null;
  var wishlistPopupInertedElements = [];
  var countrySelectorOpen = false;
  var countrySelectorOpener = null;
  var countrySelectorInertedElements = [];
  var deferredOptiMonkHolders = [];
  var optiMonkCountryObserver = null;
  var recentlyViewedOpen = false;
  var recentlyViewedInertedElements = [];
  var productInformationOpen = false;
  var productScrollLockHeld = false;
  var productInformationOpener = null;
  var pendingCartAction = null;
  var statusRegion = null;

  function isVisible(element) {
    if (!element || !(element.offsetWidth || element.offsetHeight || element.getClientRects().length)) return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.visibility !== 'collapse';
  }

  function focusableElements(container) {
    if (!container) return [];
    return Array.prototype.filter.call(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    ), function filterFocusable(element) {
      return isVisible(element) && element.tabIndex >= 0 && element.getAttribute('aria-hidden') !== 'true';
    });
  }

  function ensureStatusRegion() {
    var activeDialog = document.querySelector('[role="dialog"][aria-hidden="false"]');
    var host = activeDialog || document.body;
    statusRegion = document.getElementById('mdv-a11y-status');
    if (!statusRegion) {
      statusRegion = document.createElement('div');
      statusRegion.id = 'mdv-a11y-status';
      statusRegion.className = 'hidden-label';
      statusRegion.setAttribute('role', 'status');
      statusRegion.setAttribute('aria-live', 'polite');
      statusRegion.setAttribute('aria-atomic', 'true');
    }
    if (statusRegion.parentElement !== host) host.appendChild(statusRegion);
    return statusRegion;
  }

  function announce(message) {
    var region = ensureStatusRegion();
    region.textContent = '';
    window.setTimeout(function setAnnouncement() {
      region.textContent = message;
    }, 30);
  }

  function setDialogInert(dialog, records, shouldInert) {
    if (!dialog) return;
    if (!shouldInert) {
      records.forEach(function restoreInert(record) {
        record.element.inert = record.wasInert;
      });
      records.length = 0;
      return;
    }

    var current = dialog;
    while (current && current !== document.body) {
      var parent = current.parentElement;
      if (!parent) break;
      Array.prototype.forEach.call(parent.children, function inertSibling(sibling) {
        if (sibling === current || sibling.id === 'mdv-a11y-status' || sibling.tagName === 'SCRIPT' || sibling.tagName === 'STYLE') return;
        records.push({ element: sibling, wasInert: sibling.inert });
        sibling.inert = true;
      });
      current = parent;
    }
  }

  function trapDialogTab(event, dialog) {
    if (event.key !== 'Tab' || !dialog) return false;
    var focusable = focusableElements(dialog);
    if (!focusable.length) {
      event.preventDefault();
      dialog.focus();
      return true;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
      return true;
    }
    if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
      return true;
    }
    return false;
  }

  function setPageInert(dialog, shouldInert) {
    if (!dialog) return;
    if (!shouldInert) {
      inertedElements.forEach(function restoreInert(record) {
        record.element.inert = record.wasInert;
      });
      inertedElements = [];
      return;
    }

    var current = dialog;
    while (current && current !== document.body) {
      var parent = current.parentElement;
      if (!parent) break;
      Array.prototype.forEach.call(parent.children, function inertSibling(sibling) {
        if (sibling === current || sibling.id === 'mdv-a11y-status' || sibling.classList.contains('main-overlay_filter')) return;
        inertedElements.push({ element: sibling, wasInert: sibling.inert });
        sibling.inert = true;
      });
      current = parent;
    }
  }

  function enhanceFilterMarkup() {
    var dialog = document.querySelector('.filter-main');
    var trigger = document.querySelector('.all-filter');
    if (!dialog || !trigger) return;

    dialog.id = dialog.id || 'collection-filter-dialog';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-label', 'Filters');
    dialog.setAttribute('aria-hidden', document.body.classList.contains('active-filter') ? 'false' : 'true');
    dialog.setAttribute('tabindex', '-1');

    trigger.setAttribute('role', 'button');
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-controls', dialog.id);
    trigger.setAttribute('aria-expanded', document.body.classList.contains('active-filter') ? 'true' : 'false');

    var close = dialog.querySelector('.filter-close');
    if (close) {
      close.setAttribute('role', 'button');
      close.setAttribute('aria-label', 'Close filters');
    }

    Array.prototype.forEach.call(dialog.querySelectorAll('.filter-item-header'), function enhanceHeader(header, index) {
      var panel = header.nextElementSibling;
      if (!panel || !panel.classList.contains('filter-option-value-main')) return;
      header.setAttribute('role', 'button');
      header.setAttribute('tabindex', '0');
      header.id = header.id || 'collection-filter-heading-' + index;
      panel.id = panel.id || 'collection-filter-panel-' + index;
      var expanded = header.parentElement.classList.contains('active');
      header.setAttribute('aria-controls', panel.id);
      header.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      panel.setAttribute('aria-labelledby', header.id);
      panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
      var icon = header.querySelector('svg');
      if (icon) {
        icon.setAttribute('aria-hidden', 'true');
        icon.setAttribute('focusable', 'false');
      }
    });

    var apply = dialog.querySelector('#filter-run');
    if (apply) {
      apply.setAttribute('role', 'button');
      apply.setAttribute('tabindex', apply.classList.contains('disabled') ? '-1' : '0');
      apply.setAttribute('aria-disabled', apply.classList.contains('disabled') ? 'true' : 'false');
    }
  }

  function openFilterDialog() {
    if (filterDialogOpen) return;
    var dialog = document.querySelector('.filter-main');
    if (!dialog) return;
    filterDialogOpen = true;
    dialog.setAttribute('aria-hidden', 'false');
    var trigger = document.querySelector('.all-filter');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    setPageInert(dialog, true);
    window.requestAnimationFrame(function focusDialog() { focusFilterDialog(dialog, 0); });
  }

  function focusFilterDialog(dialog, attempt) {
    if (!filterDialogOpen || !dialog || !document.contains(dialog)) return;
    if (!isVisible(dialog)) {
      if (attempt < 10) window.setTimeout(function retryVisibleDialog() {
        focusFilterDialog(dialog, attempt + 1);
      }, 50);
      return;
    }

    var focusable = focusableElements(dialog);
    var target = focusable[0] || dialog;
    target.focus();
    if (document.activeElement !== target && attempt < 10) {
      window.setTimeout(function retryDialogFocus() {
        focusFilterDialog(dialog, attempt + 1);
      }, 50);
    }
  }

  function closeFilterDialog() {
    if (!filterDialogOpen) return;
    var dialog = document.querySelector('.filter-main');
    filterDialogOpen = false;
    if (dialog) dialog.setAttribute('aria-hidden', 'true');
    var trigger = document.querySelector('.all-filter');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    setPageInert(dialog, false);
    var returnTarget = filterOpener || trigger;
    filterOpener = null;
    if (returnTarget && document.contains(returnTarget)) returnTarget.focus();
  }

  function syncFilterDialog() {
    enhanceFilterMarkup();
    if (document.body.classList.contains('active-filter')) openFilterDialog();
    else closeFilterDialog();
  }

  function syncFilterHeader(header) {
    if (!header) return;
    var panel = header.nextElementSibling;
    if (!panel) return;
    var expanded = header.parentElement.classList.contains('active');
    header.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
  }

  function repairAccountFields() {
    Array.prototype.forEach.call(document.querySelectorAll('.wishlist-popup'), function repairPopup(popup, popupIndex) {
      Array.prototype.forEach.call(popup.querySelectorAll('.wishlist-popup-input[id]'), function repairWrapper(wrapper) {
        if (wrapper.getAttribute('data-mdv-a11y-wrapper-id')) return;
        wrapper.id = wrapper.id + '-wrapper-popup-' + popupIndex;
        wrapper.setAttribute('data-mdv-a11y-wrapper-id', 'true');
      });

      Array.prototype.forEach.call(popup.querySelectorAll('input[id], select[id], textarea[id]'), function repairField(field) {
        if (field.getAttribute('data-mdv-a11y-id')) return;
        var oldId = field.id;
        var newId = oldId + '-popup-' + popupIndex;
        Array.prototype.forEach.call(popup.querySelectorAll('label[for]'), function repairLabel(label) {
          if (label.getAttribute('for') === oldId) label.setAttribute('for', newId);
        });
        field.id = newId;
        field.setAttribute('data-mdv-a11y-id', 'true');
        if (!field.getAttribute('aria-label') && !popup.querySelector('label[for="' + newId + '"]') && field.placeholder) {
          field.setAttribute('aria-label', field.placeholder);
        }
      });
    });

    Array.prototype.forEach.call(document.querySelectorAll('input[name="customer[email]"], input[name="email"]'), function repairEmail(field) {
      field.type = 'email';
      field.autocomplete = 'email';
      field.required = true;
    });
    Array.prototype.forEach.call(document.querySelectorAll('input[name="customer[password]"]'), function repairPassword(field) {
      field.autocomplete = field.closest('.wishlist-popup.register, #customer-register') ? 'new-password' : 'current-password';
      field.required = true;
    });
    Array.prototype.forEach.call(document.querySelectorAll('input[name="customer[first_name]"]'), function repairFirstName(field) {
      field.autocomplete = 'given-name';
    });
    Array.prototype.forEach.call(document.querySelectorAll('input[name="customer[last_name]"]'), function repairLastName(field) {
      field.autocomplete = 'family-name';
    });
    Array.prototype.forEach.call(document.querySelectorAll('input[name="customer[note][birthday]"]'), function repairBirthday(field) {
      field.autocomplete = 'bday';
    });
  }

  function enhanceAccountTabs() {
    Array.prototype.forEach.call(document.querySelectorAll('.login-register-page'), function enhanceTabSet(tabSet, setIndex) {
      var tabs = Array.prototype.slice.call(tabSet.querySelectorAll('.tabs > li'));
      tabs.forEach(function enhanceTab(tab, tabIndex) {
        var panelId = tab.getAttribute('rel');
        var panel = panelId ? tabSet.querySelector('#' + panelId) : null;
        var selected = tab.classList.contains('active');
        tab.id = tab.id || 'account-tab-' + setIndex + '-' + tabIndex;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        if (panel) {
          tab.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
          panel.setAttribute('tabindex', '0');
        }
      });
      var list = tabSet.querySelector('.tabs');
      if (list) list.setAttribute('role', 'tablist');
    });
  }

  function labelIconControl(selector, label) {
    Array.prototype.forEach.call(document.querySelectorAll(selector), function labelControl(control) {
      control.setAttribute('aria-label', label);
      Array.prototype.forEach.call(control.querySelectorAll('svg'), function hideIcon(svg) {
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
      });
    });
  }

  function enhanceHeaderMarkup() {
    labelIconControl('.header li.search a, .header li.search button', 'Search');
    labelIconControl('.header li.wishlist_icon a', 'Wishlist');
    labelIconControl('.header .header-right-icon li:not(.wishlist_icon) a[href*="/account"], .header .header-right-icon li:not(.wishlist_icon) a[href*="customer_authentication"]', 'Account');
    labelIconControl('.header li.cart a, .header li.cart button', 'Shopping bag');
    labelIconControl('.header li.country a, .header li.country button', 'Change country or region');

    var cartControl = document.querySelector('.header li.cart a, .header li.cart button');
    if (cartControl) {
      if (cartControl.tagName === 'A' && !cartControl.getAttribute('href')) cartControl.setAttribute('href', '/cart');
      if (document.querySelector('.cart-page')) {
        cartControl.removeAttribute('aria-haspopup');
        cartControl.removeAttribute('aria-controls');
        cartControl.removeAttribute('aria-expanded');
      } else {
        cartControl.setAttribute('aria-haspopup', 'dialog');
        cartControl.setAttribute('aria-controls', 'shopping-bag-dialog');
        cartControl.setAttribute('aria-expanded', document.querySelector('.min-cart.active') ? 'true' : 'false');
      }
    }

    var navigation = document.querySelector('.toggol-menu .tab-view');
    if (navigation) {
      navigation.setAttribute('role', 'navigation');
      navigation.setAttribute('aria-label', 'Primary');
    }

    var menu = document.querySelector('.toggol-menu');
    var opener = document.querySelector('.header-toggle');
    if (!menu || !opener) return;
    menu.id = menu.id || 'mobile-navigation-dialog';
    menu.setAttribute('role', 'dialog');
    menu.setAttribute('aria-modal', 'true');
    menu.setAttribute('aria-label', 'Menu');
    menu.setAttribute('tabindex', '-1');
    menu.setAttribute('aria-hidden', menu.classList.contains('active') ? 'false' : 'true');
    menu.inert = !menu.classList.contains('active');
    opener.setAttribute('role', 'button');
    opener.setAttribute('tabindex', '0');
    opener.setAttribute('aria-label', 'Open menu');
    opener.setAttribute('aria-haspopup', 'dialog');
    opener.setAttribute('aria-controls', menu.id);
    opener.setAttribute('aria-expanded', menu.classList.contains('active') ? 'true' : 'false');
    var close = menu.querySelector('.toggol-menu-close');
    if (close) {
      close.setAttribute('role', 'button');
      close.setAttribute('tabindex', '0');
      close.setAttribute('aria-label', 'Close menu');
    }
  }

  function syncMobileMenuDialog() {
    enhanceHeaderMarkup();
    var menu = document.querySelector('.toggol-menu');
    var opener = document.querySelector('.header-toggle');
    if (!menu || !opener) return;
    var isOpen = menu.classList.contains('active');
    menu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    menu.inert = !isOpen;
    opener.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    if (isOpen && !mobileMenuOpen) {
      mobileMenuOpen = true;
      setDialogInert(menu, mobileMenuInertedElements, true);
      window.requestAnimationFrame(function focusMobileMenu() {
        if (!menu.classList.contains("active")) return;
        var close = menu.querySelector('.toggol-menu-close');
        (close || menu).focus();
      });
    } else if (!isOpen && mobileMenuOpen) {
      mobileMenuOpen = false;
      setDialogInert(menu, mobileMenuInertedElements, false);
      var returnTarget = mobileMenuOpener || opener;
      mobileMenuOpener = null;
      if (!document.querySelector(".search-desk-box.active") && returnTarget && document.contains(returnTarget)) returnTarget.focus({ preventScroll: true });
    }
  }

  function miniCartProductName(item) {
    var title = item && item.querySelector('.cart-title, .cart-content-title');
    var meta = item && item.querySelector('.cart-content-meta');
    var name = title && title.textContent.trim() ? title.textContent.trim() : 'item';
    var variant = meta && meta.textContent.replace(/\s+/g, ' ').trim();
    return variant ? name + ', ' + variant : name;
  }

  function enhanceMiniCartItems(cart) {
    Array.prototype.forEach.call(cart.querySelectorAll('.min-cart-col'), function enhanceItem(item) {
      var productName = miniCartProductName(item);
      var quantity = item.querySelector('.item-quantity');
      if (quantity) quantity.setAttribute('aria-label', 'Quantity for ' + productName);
      var minus = item.querySelector('.qty-nag.minus');
      if (minus) {
        minus.setAttribute('type', 'button');
        minus.setAttribute('aria-label', 'Decrease quantity for ' + productName);
      }
      var plus = item.querySelector('.qty-plus.plus');
      if (plus) {
        plus.setAttribute('type', 'button');
        plus.setAttribute('aria-label', 'Increase quantity for ' + productName);
      }
      var remove = item.querySelector('.cart-content-remove');
      if (remove) remove.setAttribute('aria-label', 'Remove ' + productName + ' from shopping bag');
    });
  }

  function enhanceMiniCartTabs(cart) {
    var tabList = cart.querySelector('.cart_tab');
    if (!tabList) return;
    var tabs = Array.prototype.slice.call(tabList.querySelectorAll('.cart-head'));
    if (!tabs.length) return;
    var panels = [cart.querySelector('.cart_tab1'), cart.querySelector('.cart_tab2')];
    var activeIndex = 0;

    tabs.forEach(function findActiveCartTab(tab, index) {
      if (tab.classList.contains('active')) activeIndex = index;
    });

    tabList.setAttribute('role', 'tablist');
    tabList.setAttribute('aria-label', 'Shopping bag views');
    tabs.forEach(function enhanceCartTab(tab, index) {
      var panel = panels[index];
      var selected = index === activeIndex;
      tab.id = tab.id || 'shopping-bag-tab-' + (index === 0 ? 'basket' : 'wishlist');
      tab.setAttribute('role', 'tab');
      tab.setAttribute('tabindex', selected ? '0' : '-1');
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      if (!panel) return;
      panel.id = panel.id || 'shopping-bag-panel-' + (index === 0 ? 'basket' : 'wishlist');
      tab.setAttribute('aria-controls', panel.id);
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tab.id);
      panel.setAttribute('aria-hidden', selected ? 'false' : 'true');
    });
  }

  function enhanceMiniCartMarkup() {
    var cart = document.querySelector('.min-cart');
    if (!cart) return;
    enhanceMiniCartTabs(cart);
    cart.id = cart.id || 'shopping-bag-dialog';
    cart.setAttribute('role', 'dialog');
    cart.setAttribute('aria-modal', 'true');
    cart.setAttribute('aria-label', 'Shopping bag');
    cart.setAttribute('tabindex', '-1');
    cart.setAttribute('aria-hidden', cart.classList.contains('active') ? 'false' : 'true');
    cart.inert = !cart.classList.contains('active');
    var close = cart.querySelector('.min-cart-close');
    if (close) {
      close.setAttribute('role', 'button');
      close.setAttribute('tabindex', '0');
      close.setAttribute('aria-label', 'Close shopping bag');
    }
    Array.prototype.forEach.call(cart.querySelectorAll('.main-overlay'), function hideOverlay(overlay) {
      overlay.setAttribute('aria-hidden', 'true');
    });
    enhanceMiniCartItems(document);
  }

  function completeCartAction() {
    var cart = pendingCartAction && pendingCartAction.scope === 'page'
      ? document.querySelector('.cart-page')
      : document.getElementById('shopping-bag-dialog');
    if (!cart) return;
    enhanceMiniCartItems(document);
    if (!pendingCartAction) return;
    var target = pendingCartAction.itemId && pendingCartAction.selector
      ? cart.querySelector('.min-cart-col[data-id="' + pendingCartAction.itemId + '"] ' + pendingCartAction.selector)
      : null;
    var item = pendingCartAction.itemId
      ? cart.querySelector('.min-cart-col[data-id="' + pendingCartAction.itemId + '"]')
      : null;
    var message = pendingCartAction.message;
    if (item && pendingCartAction.type !== 'remove') {
      var quantity = item.querySelector('.item-quantity');
      if (quantity) message = 'Quantity for ' + pendingCartAction.productName + ' updated to ' + quantity.value + '.';
    }
    announce(message);
    if (!target && pendingCartAction.type === 'remove') {
      var items = Array.prototype.slice.call(cart.querySelectorAll('.min-cart-col'));
      target = items[pendingCartAction.itemIndex] || items[pendingCartAction.itemIndex - 1] || cart.querySelector('.min-cart-checkout');
      if (target && target.classList.contains('min-cart-col')) target = focusableElements(target)[0];
    }
    if (!target) target = cart.querySelector('.min-cart-close, .min-cart-checkout');
    pendingCartAction = null;
    if (target && isVisible(target)) target.focus();
  }

  function syncMiniCartDialog() {
    enhanceMiniCartMarkup();
    var cart = document.querySelector('.min-cart');
    if (!cart) return;
    var isOpen = cart.classList.contains('active');
    cart.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    cart.inert = !isOpen;
    if (!document.querySelector('.cart-page')) {
      Array.prototype.forEach.call(document.querySelectorAll('.header li.cart a, .header li.cart button'), function syncCartControl(control) {
        control.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    if (isOpen && !miniCartOpen) {
      miniCartOpen = true;
      setDialogInert(cart, miniCartInertedElements, true);
      window.requestAnimationFrame(function focusMiniCart() {
        if (!miniCartOpen || !cart.classList.contains('active')) return;
        var close = cart.querySelector('.min-cart-close');
        (close || cart).focus();
        announce(miniCartOpener && miniCartOpener.id === 'add'
          ? 'Item added to shopping bag. Shopping bag opened.'
          : 'Shopping bag opened.');
      });
    } else if (isOpen && miniCartOpen && !cart.contains(document.activeElement) && !pendingCartAction) {
      window.requestAnimationFrame(function restoreMiniCartFocusAfterRefresh() {
        if (!miniCartOpen || !cart.classList.contains('active')) return;
        var close = cart.querySelector('.min-cart-close');
        (close || cart).focus();
      });
    } else if (!isOpen && miniCartOpen) {
      miniCartOpen = false;
      setDialogInert(cart, miniCartInertedElements, false);
      var returnTarget = miniCartOpener;
      miniCartOpener = null;
      if (returnTarget && document.contains(returnTarget) && !document.querySelector('.country-selector.custom-country-selector.active')) returnTarget.focus();
    }
  }

  function syncRecommendationSlides() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-mdv-recs] .mdv-recs-swiper'), function syncCarousel(carousel) {
      carousel.setAttribute('role', 'region');
      carousel.setAttribute('aria-roledescription', 'carousel');
      carousel.setAttribute('aria-label', 'Product recommendations. Use the left and right arrow keys to browse.');
      carousel.setAttribute('tabindex', '0');
      var carouselRect = carousel.getBoundingClientRect();
      Array.prototype.forEach.call(carousel.querySelectorAll('.mdv-recs-slide'), function syncSlide(slide) {
        var rect = slide.getBoundingClientRect();
        var measurable = carouselRect.width > 0 && carouselRect.height > 0 && rect.width > 0 && rect.height > 0;
        var visible = !measurable || (
          rect.right > carouselRect.left + 1 && rect.left < carouselRect.right - 1 &&
          rect.bottom > carouselRect.top + 1 && rect.top < carouselRect.bottom - 1
        );
        slide.setAttribute('aria-hidden', visible ? 'false' : 'true');
        Array.prototype.forEach.call(slide.querySelectorAll('a, button, input, select, textarea, [tabindex]'), function syncFocusable(element) {
          if (!element.hasAttribute('data-mdv-a11y-tabindex')) {
            element.setAttribute('data-mdv-a11y-tabindex', element.hasAttribute('tabindex') ? element.getAttribute('tabindex') : '');
          }
          if (!visible) element.setAttribute('tabindex', '-1');
          else {
            var original = element.getAttribute('data-mdv-a11y-tabindex');
            if (original === '') element.removeAttribute('tabindex');
            else element.setAttribute('tabindex', original);
          }
        });
      });
    });
  }

  function isInlineWishlistPopup(popup) {
    return !!(popup && popup.closest('.cart_tab2'));
  }

  function enhanceWishlistDialogs() {
    Array.prototype.forEach.call(document.querySelectorAll('.wishlist-popup'), function enhancePopup(popup, index) {
      var title = popup.querySelector('.wishlist-popup-title');
      var close = popup.querySelector('.wishlist-popup-close');
      var isOpen = popup.classList.contains('active') && isVisible(popup);
      var isInline = isInlineWishlistPopup(popup);
      popup.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      popup.inert = !isOpen;
      if (isInline) {
        popup.removeAttribute('role');
        popup.removeAttribute('aria-modal');
        popup.removeAttribute('tabindex');
      } else {
        popup.setAttribute('role', 'dialog');
        popup.setAttribute('aria-modal', 'true');
        popup.setAttribute('tabindex', '-1');
      }
      if (title) {
        title.id = title.id || 'wishlist-dialog-title-' + index;
        popup.setAttribute('aria-labelledby', title.id);
      } else {
        popup.setAttribute('aria-label', 'Wishlist account');
      }
      if (close) {
        if (isInline) {
          close.removeAttribute('role');
          close.removeAttribute('tabindex');
          close.removeAttribute('aria-label');
        } else {
          close.setAttribute('role', 'button');
          close.setAttribute('tabindex', '0');
          close.setAttribute('aria-label', 'Close account dialog');
        }
      }
      Array.prototype.forEach.call(popup.querySelectorAll('.main-overlay'), function hideOverlay(overlay) {
        overlay.setAttribute('aria-hidden', 'true');
      });
    });
  }

  function syncWishlistDialog() {
    enhanceWishlistDialogs();
    var nextPopup = Array.prototype.filter.call(document.querySelectorAll('body > .wishlist-popup.active'), isVisible)[0] || null;
    if (nextPopup === wishlistPopupOpen) return;

    if (wishlistPopupOpen) setDialogInert(wishlistPopupOpen, wishlistPopupInertedElements, false);
    wishlistPopupOpen = nextPopup;

    if (wishlistPopupOpen) {
      setDialogInert(wishlistPopupOpen, wishlistPopupInertedElements, true);
      window.requestAnimationFrame(function focusWishlistPopup() {
        var close = wishlistPopupOpen && wishlistPopupOpen.querySelector('.wishlist-popup-close');
        (close || wishlistPopupOpen).focus();
      });
    } else {
      var returnTarget = wishlistPopupOpener;
      wishlistPopupOpener = null;
      if (returnTarget && document.contains(returnTarget)) returnTarget.focus();
    }
  }

  function listboxId(listbox, prefix, index) {
    listbox.id = listbox.id || prefix + '-' + index;
    listbox.setAttribute('role', 'listbox');
    Array.prototype.forEach.call(listbox.querySelectorAll('li'), function enhanceOption(option) {
      option.setAttribute('role', 'option');
      option.setAttribute('tabindex', '-1');
      option.setAttribute('aria-selected', option.classList.contains('active') ? 'true' : 'false');
    });
    return listbox.id;
  }

  function enhanceCountrySelector() {
    var selector = document.querySelector('.country-selector.custom-country-selector');
    if (!selector) return;
    var isOpen = selector.classList.contains('active') && !selector.hasAttribute('data-mdv-bag-deferred') && isVisible(selector);
    selector.setAttribute('role', 'dialog');
    selector.setAttribute('aria-modal', 'true');
    selector.setAttribute('aria-label', 'Country, language and currency');
    selector.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    selector.setAttribute('tabindex', '-1');
    selector.inert = !isOpen;

    var close = selector.querySelector('.country-selector-close');
    if (close) {
      close.setAttribute('role', 'button');
      close.setAttribute('tabindex', '0');
      close.setAttribute('aria-label', 'Close country selector');
    }
    var overlay = selector.querySelector('.main-overlay');
    if (overlay) overlay.setAttribute('aria-hidden', 'true');

    Array.prototype.forEach.call(selector.querySelectorAll('.country-selector-option'), function enhanceCountryList(list, index) {
      var input = list.parentElement && list.parentElement.querySelector('.country-selector-zone');
      var id = listboxId(list, 'country-options', index);
      if (input) {
        input.setAttribute('role', 'combobox');
        input.setAttribute('aria-autocomplete', 'list');
        input.setAttribute('aria-haspopup', 'listbox');
        input.setAttribute('aria-controls', id);
        input.setAttribute('aria-expanded', list.classList.contains('active') ? 'true' : 'false');
        input.setAttribute('aria-label', 'Country');
      }
    });

    Array.prototype.forEach.call(selector.querySelectorAll('.price-select ul.small'), function enhanceCurrencyList(list, index) {
      var control = list.parentElement && list.parentElement.querySelector('.price-select-value');
      var id = listboxId(list, 'currency-options', index);
      if (control) {
        control.setAttribute('role', 'button');
        control.setAttribute('tabindex', '0');
        control.setAttribute('aria-label', 'Currency');
        control.setAttribute('aria-haspopup', 'listbox');
        control.setAttribute('aria-controls', id);
        control.setAttribute('aria-expanded', list.classList.contains('active') ? 'true' : 'false');
      }
    });

    Array.prototype.forEach.call(selector.querySelectorAll('.language-select-option'), function enhanceLanguageList(list, index) {
      var control = list.parentElement && list.parentElement.querySelector('.language-select-value');
      var id = listboxId(list, 'language-options', index);
      if (control) {
        control.setAttribute('role', 'button');
        control.setAttribute('tabindex', '0');
        control.setAttribute('aria-label', 'Language');
        control.setAttribute('aria-haspopup', 'listbox');
        control.setAttribute('aria-controls', id);
        control.setAttribute('aria-expanded', list.classList.contains('active') ? 'true' : 'false');
      }
    });

    var error = selector.querySelector('.country-selector-error');
    if (error) {
      error.setAttribute('role', 'alert');
      error.setAttribute('aria-live', 'assertive');
    }
  }

  function ensureOptiMonkCountryDeferralStyle() {
    if (document.getElementById('mdv-optimonk-country-deferral-style')) return;
    var style = document.createElement('style');
    style.id = 'mdv-optimonk-country-deferral-style';
    style.textContent = '.om-holder[data-mdv-country-deferred]{visibility:hidden!important;opacity:0!important;pointer-events:none!important}';
    (document.head || document.documentElement).appendChild(style);
  }

  function suspendOptiMonkForCountrySelector() {
    if (!countrySelectorOpen) return;
    Array.prototype.forEach.call(document.querySelectorAll('.om-holder'), function suspendHolder(holder) {
      var record = deferredOptiMonkHolders.filter(function findRecord(candidate) {
        return candidate.element === holder;
      })[0];
      if (!record) {
        record = {
          element: holder,
          hadAriaHidden: holder.hasAttribute('aria-hidden'),
          ariaHidden: holder.getAttribute('aria-hidden'),
          wasInert: holder.inert
        };
        deferredOptiMonkHolders.push(record);
      }
      holder.setAttribute('data-mdv-country-deferred', '');
      holder.setAttribute('aria-hidden', 'true');
      holder.inert = true;
    });

    var selector = document.querySelector('.country-selector.custom-country-selector');
    if (selector && !selector.contains(document.activeElement)) {
      var close = selector.querySelector('.country-selector-close');
      (close || selector).focus();
    }
  }

  function startOptiMonkCountryDeferral() {
    ensureOptiMonkCountryDeferralStyle();
    suspendOptiMonkForCountrySelector();
    if (optiMonkCountryObserver || !document.body) return;
    optiMonkCountryObserver = new MutationObserver(suspendOptiMonkForCountrySelector);
    optiMonkCountryObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  function stopOptiMonkCountryDeferral() {
    if (optiMonkCountryObserver) optiMonkCountryObserver.disconnect();
    optiMonkCountryObserver = null;
    deferredOptiMonkHolders.forEach(function restoreHolder(record) {
      if (!document.contains(record.element)) return;
      if (record.hadAriaHidden) record.element.setAttribute('aria-hidden', record.ariaHidden);
      else record.element.removeAttribute('aria-hidden');
      record.element.inert = record.wasInert;
      record.element.removeAttribute('data-mdv-country-deferred');
    });
    deferredOptiMonkHolders = [];
  }

  function syncCartAndCountryDialogs() {
    var selector = document.querySelector('.country-selector.custom-country-selector');
    var cartRequested = !!document.querySelector('.min-cart.active');
    if (selector && cartRequested) {
      if (countrySelectorOpen) {
        setDialogInert(selector, countrySelectorInertedElements, false);
        countrySelectorOpen = false;
        stopOptiMonkCountryDeferral();
      }
      selector.setAttribute('data-mdv-bag-deferred', '');
      enhanceCountrySelector();
      document.body.classList.add('no-scroll');
    }
    if (!cartRequested && selector && selector.classList.contains('active') && !countrySelectorOpener) {
      countrySelectorOpener = miniCartOpener;
    }
    syncMiniCartDialog();
    if (selector && !cartRequested) selector.removeAttribute('data-mdv-bag-deferred');
    syncCountrySelector();
  }

  function syncCountrySelector() {
    enhanceCountrySelector();
    var selector = document.querySelector('.country-selector.custom-country-selector');
    if (!selector) return;
    var isOpen = selector.classList.contains('active') && !selector.hasAttribute('data-mdv-bag-deferred') && isVisible(selector);
    if (isOpen === countrySelectorOpen) return;
    countrySelectorOpen = isOpen;

    if (isOpen) {
      startOptiMonkCountryDeferral();
      setDialogInert(selector, countrySelectorInertedElements, true);
      document.body.classList.add('no-scroll');
      window.requestAnimationFrame(function focusCountrySelector() {
        if (!countrySelectorOpen || miniCartOpen || !selector.classList.contains('active') || selector.hasAttribute('data-mdv-bag-deferred')) return;
        var close = selector.querySelector('.country-selector-close');
        (close || selector).focus();
      });
    } else {
      setDialogInert(selector, countrySelectorInertedElements, false);
      stopOptiMonkCountryDeferral();
      var returnTarget = countrySelectorOpener;
      countrySelectorOpener = null;
      if (returnTarget && document.contains(returnTarget)) returnTarget.focus();
    }
  }

  function enhanceSupportingMarkup() {
    Array.prototype.forEach.call(document.querySelectorAll('.social-media-icons a'), function labelSocialLink(link) {
      if (link.getAttribute('aria-label')) return;
      var href = (link.getAttribute('href') || '').toLowerCase();
      var network = ['instagram', 'facebook', 'twitter', 'x.com', 'pinterest', 'youtube', 'tiktok'].filter(function matchNetwork(name) {
        return href.indexOf(name) !== -1;
      })[0];
      if (network) link.setAttribute('aria-label', (network === 'x.com' ? 'X' : network.charAt(0).toUpperCase() + network.slice(1)) + ' (opens in a new tab)');
    });

    Array.prototype.forEach.call(document.querySelectorAll('.klaviyo_messages .success_message'), function labelSuccess(message) {
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
      message.setAttribute('aria-atomic', 'true');
    });
    Array.prototype.forEach.call(document.querySelectorAll('.klaviyo_messages .error_message'), function labelError(message) {
      message.setAttribute('role', 'alert');
      message.setAttribute('aria-live', 'assertive');
      message.setAttribute('aria-atomic', 'true');
    });

    var cookieNotice = document.getElementById('cookies-notification');
    if (cookieNotice) {
      cookieNotice.setAttribute('role', 'region');
      cookieNotice.setAttribute('aria-label', 'Cookie preferences');
    }

    Array.prototype.forEach.call(document.querySelectorAll('.BIS_trigger, #coming-soon-with-get-notified, #coming-soon-with-get-notified-overlay'), function enhanceStockTrigger(trigger) {
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('aria-haspopup', 'dialog');
      if (!trigger.getAttribute('aria-label')) trigger.setAttribute('aria-label', trigger.textContent.trim() || 'Notify me when available');
    });

    Array.prototype.forEach.call(document.querySelectorAll('iframe:not([title])'), function labelKnownIframe(frame) {
      var source = (frame.getAttribute('src') || '').toLowerCase();
      if (/back.?in.?stock|klaviyo|notify/.test(source)) frame.setAttribute('title', 'Back in stock notification');
    });
  }

  function enhanceNavigationSubmenus() {
    Array.prototype.forEach.call(document.querySelectorAll('.toggol-menu li[rel]'), function enhanceTopItem(item, index) {
      var control = item.querySelector(':scope > a.use-js-title-one');
      var panel = item.querySelector(':scope > .toggol-menu-list');
      if (!control || !panel) return;
      panel.id = panel.id || 'mobile-menu-panel-' + index;
      control.setAttribute('aria-controls', panel.id);
      control.setAttribute('aria-expanded', item.classList.contains('active') || control.classList.contains('active') || control.classList.contains('open_one') ? 'true' : 'false');
    });
    Array.prototype.forEach.call(document.querySelectorAll('.toggol-menu .submenu-2-head'), function enhanceSecondItem(item, index) {
      var control = item.querySelector(':scope > a.use-js-title-two');
      var panel = item.querySelector(':scope > .third-level-menu');
      if (!control || !panel) return;
      panel.id = panel.id || 'mobile-submenu-panel-' + index;
      control.setAttribute('aria-controls', panel.id);
      control.setAttribute('aria-expanded', item.classList.contains('active') || control.classList.contains('active') ? 'true' : 'false');
    });
  }

  function syncHeroSlides() {
    Array.prototype.forEach.call(document.querySelectorAll('.sale-slider-deta'), function syncHero(carousel) {
      var carouselRect = carousel.getBoundingClientRect();
      Array.prototype.forEach.call(carousel.querySelectorAll('.swiper-slide'), function syncSlide(slide) {
        var rect = slide.getBoundingClientRect();
        var measurable = carouselRect.width > 0 && carouselRect.height > 0 && rect.width > 0 && rect.height > 0;
        var visible = !slide.classList.contains('swiper-slide-duplicate') && (!measurable || (
          rect.right > carouselRect.left + 1 && rect.left < carouselRect.right - 1 &&
          rect.bottom > carouselRect.top + 1 && rect.top < carouselRect.bottom - 1
        ));
        slide.setAttribute('aria-hidden', visible ? 'false' : 'true');
        Array.prototype.forEach.call(slide.querySelectorAll('a, button, input, select, textarea, [tabindex]'), function syncFocusable(element) {
          if (!element.hasAttribute('data-mdv-a11y-tabindex')) {
            element.setAttribute('data-mdv-a11y-tabindex', element.hasAttribute('tabindex') ? element.getAttribute('tabindex') : '');
          }
          if (!visible) element.setAttribute('tabindex', '-1');
          else {
            var original = element.getAttribute('data-mdv-a11y-tabindex');
            if (original === '') element.removeAttribute('tabindex');
            else element.setAttribute('tabindex', original);
          }
        });
        Array.prototype.forEach.call(slide.querySelectorAll('.sale-slider-img > a'), function hideRedundantImageLink(link) {
          link.setAttribute('aria-hidden', 'true');
          link.setAttribute('tabindex', '-1');
        });
      });
    });
  }

  function enhanceFooterAccordions() {
    var mobile = window.matchMedia('(max-width: 767px)').matches;
    Array.prototype.forEach.call(document.querySelectorAll('.footer-menu-right .footer_menu_col:not(.one_menu) > h3'), function enhanceHeading(heading, index) {
      var panel = heading.nextElementSibling;
      if (!panel || !panel.classList.contains('footer_ul')) return;
      panel.id = panel.id || 'footer-menu-panel-' + index;
      if (mobile) {
        heading.setAttribute('role', 'button');
        heading.setAttribute('tabindex', '0');
        heading.setAttribute('aria-controls', panel.id);
        heading.setAttribute('aria-expanded', heading.classList.contains('active') ? 'true' : 'false');
      } else {
        heading.removeAttribute('role');
        heading.removeAttribute('tabindex');
        heading.removeAttribute('aria-controls');
        heading.removeAttribute('aria-expanded');
      }
    });
  }

  function enhanceProductTabs() {
    Array.prototype.forEach.call(document.querySelectorAll('.product_tabs_new .tabcontent'), function labelPanel(panel, index) {
      panel.id = panel.id || 'product-information-panel-' + index;
      panel.setAttribute('role', 'region');
    });
    Array.prototype.forEach.call(document.querySelectorAll('.product_tabs_new .tablinks'), function enhanceTab(control) {
      var wrapper = control.closest('.product_tabs_new');
      var popupId = control.getAttribute('id');
      var panel = wrapper && popupId ? wrapper.querySelector('.tabcontent[data-tab="' + popupId + '"]') : null;
      if (!panel && popupId) {
        panel = document.querySelector('.product_tabs_popup .tabcontent[data-tab="popup-' + popupId + '"]');
      }
      control.setAttribute('role', 'button');
      control.setAttribute('tabindex', '0');
      control.setAttribute('aria-expanded', control.classList.contains('active') ? 'true' : 'false');
      if (panel) control.setAttribute('aria-controls', panel.id);
    });
  }

  function syncProductScrollLock() {
    if (sizeGuideOpen) {
      productScrollLockHeld = true;
      document.body.classList.add('no-scroll');
    } else if (productScrollLockHeld) {
      productScrollLockHeld = false;
      var anotherOverlay = Array.prototype.some.call(document.querySelectorAll('.min-cart.active, .search-desk-box.active, .toggol-menu.active, body > .wishlist-popup.active, .country-selector.active, .recently-viewed-products.active'), isVisible);
      if (!anotherOverlay && !document.body.classList.contains('active-filter')) {
        document.body.classList.remove('no-scroll');
      }
    }
  }

  function enhanceProductInformationDialog() {
    var dialog = document.querySelector('.product_tabs_popup');
    if (!dialog) return;
    var isOpen = dialog.classList.contains('active') && isVisible(dialog);
    // Product information is a nonmodal panel; the header remains available.
    dialog.setAttribute('role', 'region');
    dialog.removeAttribute('aria-modal');
    dialog.setAttribute('aria-label', 'Product information');
    dialog.setAttribute('tabindex', '-1');
    dialog.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    if (!isOpen) dialog.inert = true;
    var close = dialog.querySelector('#closetabing');
    if (close) {
      close.setAttribute('role', 'button');
      close.setAttribute('tabindex', '0');
      close.setAttribute('aria-label', 'Close product information');
    }
  }

  function syncProductInformationDialog() {
    enhanceProductTabs();
    var dialog = document.querySelector('.product_tabs_popup');
    if (!dialog) return;
    var isOpen = dialog.classList.contains('active') && isVisible(dialog);
    var focusWasInside = dialog.contains(document.activeElement);
    enhanceProductInformationDialog();

    if (isOpen && !productInformationOpen) {
      productInformationOpen = true;
      // Do not undo inertness owned by an open modal, including on resize.
      var anotherModalOpen = sizeGuideOpen || miniCartOpen || mobileMenuOpen || wishlistPopupOpen || countrySelectorOpen || recentlyViewedOpen || filterDialogOpen || document.querySelector('.search-desk-box.active');
      if (!anotherModalOpen) dialog.inert = false;
    } else if (!isOpen && productInformationOpen) {
      productInformationOpen = false;
      var returnTarget = productInformationOpener;
      productInformationOpener = null;
      if (focusWasInside && !sizeGuideOpen && returnTarget && document.contains(returnTarget) && !returnTarget.closest('[inert]')) {
        returnTarget.focus({ preventScroll: true });
      }
    }
    syncProductScrollLock();
  }

  var sizeGuideRelease = 'mdv-size-guide-dialog-v3';
  var sizeGuideOpen = false;
  var sizeGuideOpener = null;
  var sizeGuideInertedElements = [];

  function enhanceSizeGuideDialog() {
    var dialog = document.querySelector('.size_guide_popup');
    if (!dialog) return;

    var isOpen = dialog.classList.contains('active');
    dialog.setAttribute('data-mdv-release', sizeGuideRelease);
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-label', 'Size guide');
    dialog.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    dialog.setAttribute('tabindex', '-1');
    if (isOpen && dialog.hasAttribute('inert')) dialog.removeAttribute('inert');
    else if (!isOpen && !dialog.hasAttribute('inert')) dialog.setAttribute('inert', '');

    var close = dialog.querySelector('.sg_close_btn');
    if (close) {
      close.setAttribute('role', 'button');
      close.setAttribute('tabindex', '0');
      close.setAttribute('aria-label', 'Close size guide');
    }

    var overlay = dialog.querySelector('.main-overlay');
    if (overlay) overlay.setAttribute('aria-hidden', 'true');
  }

  function focusSizeGuideDialog(dialog) {
    if (!sizeGuideOpen || !dialog || !document.contains(dialog)) return;
    var target = dialog.querySelector('.sg_close_btn') || focusableElements(dialog)[0] || dialog;
    target.focus();
  }

  function syncSizeGuideDialog() {
    var dialog = document.querySelector('.size_guide_popup');
    if (!dialog) return;

    var isOpen = dialog.classList.contains('active');
    enhanceSizeGuideDialog();

    if (isOpen && !sizeGuideOpen) {
      sizeGuideOpen = true;
      if (!sizeGuideOpener && document.activeElement && !dialog.contains(document.activeElement)) {
        sizeGuideOpener = document.activeElement;
      }
      setDialogInert(dialog, sizeGuideInertedElements, true);
      syncProductScrollLock();
      window.requestAnimationFrame(function firstSizeGuideFocusFrame() {
        window.requestAnimationFrame(function focusOpenedSizeGuide() {
          focusSizeGuideDialog(dialog);
        });
      });
      return;
    }

    if (!isOpen && sizeGuideOpen) {
      sizeGuideOpen = false;
      setDialogInert(dialog, sizeGuideInertedElements, false);
      syncProductInformationDialog();
      syncProductScrollLock();

      var returnTarget = sizeGuideOpener;
      sizeGuideOpener = null;
      if (returnTarget && document.contains(returnTarget)) returnTarget.focus();
    }
  }

  function initializeSizeGuideDialog() {
    var dialog = document.querySelector('.size_guide_popup');
    if (!dialog) return;

    syncSizeGuideDialog();

    var observer = new MutationObserver(syncSizeGuideDialog);
    observer.observe(dialog, { attributes: true, attributeFilter: ['class', 'inert'] });

    document.addEventListener('click', function handleSizeGuideClick(event) {
      var target = event.target && event.target.closest ? event.target : null;
      if (!target) return;

      var trigger = target.closest('.size-guide .trigger');
      if (trigger) {
        sizeGuideOpener = trigger.closest('a, button, [tabindex]') || trigger;
        window.setTimeout(syncSizeGuideDialog, 0);
      }

      if (target.closest('.sg_close_btn, .size_guide_popup .main-overlay')) {
        window.setTimeout(syncSizeGuideDialog, 0);
      }
    }, true);

    window.addEventListener('keydown', function handleSizeGuideKeydown(event) {
      if (!sizeGuideOpen || (event.key !== 'Escape' && event.key !== 'Tab')) return;

      var activeDialog = document.querySelector('.size_guide_popup');
      if (!activeDialog) return;

      event.stopImmediatePropagation();
      if (event.key === 'Escape') {
        event.preventDefault();
        var close = activeDialog.querySelector('.sg_close_btn');
        if (close) close.click();
        return;
      }

      trapDialogTab(event, activeDialog);
    }, true);
  }

  function enhanceRecentlyViewed() {
    var drawer = document.querySelector('.recently-viewed-products');
    if (!drawer) return;
    var isOpen = drawer.classList.contains('active');
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Recently viewed products');
    drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    drawer.setAttribute('tabindex', '-1');
    drawer.inert = !isOpen;
    var close = drawer.querySelector('.recently-products-close');
    if (close) {
      close.setAttribute('role', 'button');
      close.setAttribute('tabindex', '0');
      close.setAttribute('aria-label', 'Close recently viewed products');
    }
    var overlay = drawer.querySelector('.main-overlay');
    if (overlay) overlay.setAttribute('aria-hidden', 'true');
  }

  function syncRecentlyViewed() {
    enhanceRecentlyViewed();
    var drawer = document.querySelector('.recently-viewed-products');
    if (!drawer) return;
    var isOpen = drawer.classList.contains('active');
    if (isOpen === recentlyViewedOpen) return;
    recentlyViewedOpen = isOpen;
    if (isOpen) {
      setDialogInert(drawer, recentlyViewedInertedElements, true);
      window.requestAnimationFrame(function focusRecentlyViewed() {
        var close = drawer.querySelector('.recently-products-close');
        (close || drawer).focus();
      });
    } else {
      setDialogInert(drawer, recentlyViewedInertedElements, false);
    }
  }

  document.addEventListener('click', function handleClick(event) {
    var menuTrigger = event.target.closest('.header-toggle');
    if (menuTrigger) mobileMenuOpener = menuTrigger;

    var wishlistTrigger = event.target.closest('.header li.wishlist_icon a, #ws-fav-btn, [data-wishlist-trigger]');
    if (wishlistTrigger) wishlistPopupOpener = wishlistTrigger;

    var countryTrigger = event.target.closest('.header-style-one li.country, .pass-right-icon');
    if (countryTrigger) {
      countrySelectorOpener = countryTrigger.querySelector('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])') || countryTrigger;
    }

    var miniCartTrigger = event.target.closest('#add, .header li.cart a, .header li.cart button');
    if (miniCartTrigger) miniCartOpener = miniCartTrigger;

    var cartAction = event.target.closest('.qty-plus.plus, .qty-nag.minus, .cart-content-remove');
    if (cartAction) {
      var item = cartAction.closest('.min-cart-col');
      var itemRoot = cartAction.closest('.min-cart-main') || cartAction.closest('.cart-page');
      var itemIndex = itemRoot && item ? Array.prototype.indexOf.call(itemRoot.querySelectorAll('.min-cart-col'), item) : 0;
      var productName = miniCartProductName(item);
      var type = cartAction.classList.contains('cart-content-remove')
        ? 'remove'
        : (cartAction.classList.contains('plus') ? 'increase' : 'decrease');
      pendingCartAction = {
        type: type,
        itemId: item ? item.getAttribute('data-id') : '',
        itemIndex: itemIndex,
        scope: cartAction.closest('.cart-page') ? 'page' : 'drawer',
        productName: productName,
        selector: type === 'increase' ? '.qty-plus.plus' : (type === 'decrease' ? '.qty-nag.minus' : ''),
        message: type === 'remove'
          ? productName + ' removed from shopping bag.'
          : 'Updating quantity for ' + productName + '.'
      };
    }

    var trigger = event.target.closest('.all-filter');
    if (trigger) filterOpener = trigger;

    var header = event.target.closest('.filter-item-header');
    if (header) window.requestAnimationFrame(function syncHeaderAfterClick() { syncFilterHeader(header); });

    if (event.target.closest('.all-filter, .filter-close, .main-overlay_filter, #filter-run')) {
      window.setTimeout(syncFilterDialog, 0);
    }

    if (event.target.closest('.wishlist-popup-close, .wishlist-popup .main-overlay, .popup-register-link, #ws-fav-btn, .header li.wishlist_icon a, .cart_tab .cart-head')) {
      window.setTimeout(function syncWishlistAndCartTabsAfterClick() {
        enhanceMiniCartMarkup();
        syncWishlistDialog();
      }, 0);
    }

    if (event.target.closest('.country-selector-close, .country-selector .main-overlay, .header-style-one li.country, .pass-right-icon, .country-selector-option li, .price-select li, .language-select-option li, .country-selector-zone, .price-select-value, .language-select-value')) {
      window.setTimeout(syncCartAndCountryDialogs, 0);
    }

    if (event.target.closest('.footer-menu-right h3')) window.setTimeout(enhanceFooterAccordions, 0);
    var productInformationTrigger = event.target.closest('.product_tabs_new .tablinks');
    if (productInformationTrigger && !productInformationTrigger.closest('.product_tabs_popup')) {
      productInformationOpener = productInformationTrigger;
    }
    if (event.target.closest('.product_tabs_new .tablinks, .product_tabs_new #closetabing')) {
      window.setTimeout(syncProductInformationDialog, 0);
    }

    var accountTab = event.target.closest('.login-register-page .tabs > li');
    if (accountTab) window.setTimeout(enhanceAccountTabs, 0);

    if (event.target.closest('.forgot-link')) {
      window.setTimeout(function focusRevealedAccountForm() {
        var recover = document.querySelector('#recover-password');
        var login = document.querySelector('#main-login');
        var visibleForm = recover && isVisible(recover) ? recover : login;
        var field = visibleForm && visibleForm.querySelector('input:not([type="hidden"])');
        if (field) field.focus();
      }, 0);
    }
  }, true);

  window.addEventListener('keydown', function protectCountrySelectorEscape(event) {
    if (event.key !== 'Escape' || document.querySelector('.min-cart.active')) return;
    var countrySelector = document.querySelector('.country-selector.custom-country-selector');
    if (!countrySelector || countrySelector.hasAttribute('data-mdv-bag-deferred') || !countrySelector.classList.contains('active') || !isVisible(countrySelector)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var countryClose = countrySelector.querySelector('.country-selector-close');
    if (countryClose) countryClose.click();
  }, true);

  document.addEventListener('keydown', function handleKeydown(event) {
    var roleButton = event.target.closest('[role="button"]');
    if (roleButton && (event.key === ' ' || (event.key === 'Enter' && !/^(A|BUTTON|INPUT)$/i.test(roleButton.tagName)))) {
      event.preventDefault();
      roleButton.click();
      return;
    }

    var cartTab = event.target.closest('.cart_tab [role="tab"]');
    if (cartTab && ['ArrowLeft', 'ArrowRight', 'Home', 'End', 'Enter', ' '].indexOf(event.key) !== -1) {
      var cartTabs = Array.prototype.slice.call(cartTab.closest('[role="tablist"]').querySelectorAll('[role="tab"]'));
      var cartTabIndex = cartTabs.indexOf(cartTab);
      if (event.key === 'ArrowRight') cartTabIndex = (cartTabIndex + 1) % cartTabs.length;
      if (event.key === 'ArrowLeft') cartTabIndex = (cartTabIndex - 1 + cartTabs.length) % cartTabs.length;
      if (event.key === 'Home') cartTabIndex = 0;
      if (event.key === 'End') cartTabIndex = cartTabs.length - 1;
      event.preventDefault();
      cartTabs[cartTabIndex].click();
      cartTabs[cartTabIndex].focus();
      window.setTimeout(function syncCartTabsAfterKeyboardActivation() {
        enhanceMiniCartMarkup();
        syncWishlistDialog();
      }, 0);
      return;
    }

    var accountTab = event.target.closest('.login-register-page [role="tab"]');
    if (accountTab && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) !== -1) {
      var tabs = Array.prototype.slice.call(accountTab.closest('[role="tablist"]').querySelectorAll('[role="tab"]'));
      var index = tabs.indexOf(accountTab);
      if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') index = 0;
      if (event.key === 'End') index = tabs.length - 1;
      event.preventDefault();
      tabs[index].click();
      tabs[index].focus();
      return;
    }

    var recommendationCarousel = event.target.closest('[data-mdv-recs] .mdv-recs-swiper');
    if (recommendationCarousel && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
      var recommendationSwiper = recommendationCarousel.swiper;
      if (recommendationSwiper) {
        event.preventDefault();
        if (event.key === 'ArrowLeft') recommendationSwiper.slidePrev();
        else recommendationSwiper.slideNext();
        window.setTimeout(syncRecommendationSlides, 50);
      }
      return;
    }

    if (miniCartOpen) {
      var miniCart = document.querySelector('.min-cart');
      if (event.key === 'Escape') {
        event.preventDefault();
        var miniCartClose = miniCart && miniCart.querySelector('.min-cart-close');
        if (miniCartClose) miniCartClose.click();
        return;
      }
      if (trapDialogTab(event, miniCart)) return;
    }

    if (mobileMenuOpen) {
      var mobileMenu = document.querySelector('.toggol-menu');
      if (event.key === 'Escape') {
        event.preventDefault();
        var menuClose = mobileMenu && mobileMenu.querySelector('.toggol-menu-close');
        if (menuClose) menuClose.click();
        return;
      }
      if (trapDialogTab(event, mobileMenu)) return;
    }

    if (productInformationOpen && event.target.closest('.product_tabs_popup')) {
      var productInformationDialog = document.querySelector('.product_tabs_popup');
      if (event.key === 'Escape') {
        event.preventDefault();
        var productInformationClose = productInformationDialog && productInformationDialog.querySelector('#closetabing');
        if (productInformationClose) productInformationClose.click();
        return;
      }
    }

    if (wishlistPopupOpen) {
      if (event.key === 'Escape') {
        event.preventDefault();
        var wishlistClose = wishlistPopupOpen.querySelector('.wishlist-popup-close');
        if (wishlistClose) wishlistClose.click();
        return;
      }
      if (trapDialogTab(event, wishlistPopupOpen)) return;
    }

    if (countrySelectorOpen) {
      var countrySelector = document.querySelector('.country-selector.custom-country-selector');
      if (event.key === 'Escape') {
        event.preventDefault();
        var countryClose = countrySelector && countrySelector.querySelector('.country-selector-close');
        if (countryClose) countryClose.click();
        return;
      }
      if (trapDialogTab(event, countrySelector)) return;
    }

    if (recentlyViewedOpen) {
      var recentlyViewed = document.querySelector('.recently-viewed-products');
      if (event.key === 'Escape') {
        event.preventDefault();
        var recentlyViewedClose = recentlyViewed && recentlyViewed.querySelector('.recently-products-close');
        if (recentlyViewedClose) recentlyViewedClose.click();
        return;
      }
      if (trapDialogTab(event, recentlyViewed)) return;
    }

    var listOption = event.target.closest('[role="option"]');
    if (listOption && ['ArrowDown', 'ArrowUp', 'Home', 'End', 'Enter', ' '].indexOf(event.key) !== -1) {
      var options = Array.prototype.filter.call(listOption.parentElement.querySelectorAll('[role="option"]'), isVisible);
      var optionIndex = options.indexOf(listOption);
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        listOption.click();
      } else if (options.length) {
        if (event.key === 'ArrowDown') optionIndex = (optionIndex + 1) % options.length;
        if (event.key === 'ArrowUp') optionIndex = (optionIndex - 1 + options.length) % options.length;
        if (event.key === 'Home') optionIndex = 0;
        if (event.key === 'End') optionIndex = options.length - 1;
        event.preventDefault();
        options[optionIndex].focus();
      }
      return;
    }

    if (!filterDialogOpen) return;
    var dialog = document.querySelector('.filter-main');
    if (!dialog) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      var close = dialog.querySelector('.filter-close');
      if (close) close.click();
      else document.body.classList.remove('active-filter');
      return;
    }
    if (event.key !== 'Tab') return;
    var focusable = focusableElements(dialog);
    if (!focusable.length) {
      event.preventDefault();
      dialog.focus();
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  function initialize() {
    var cartCountryStyle = document.createElement('style');
    cartCountryStyle.textContent = '.country-selector.custom-country-selector[data-mdv-bag-deferred] { display: none !important; }';
    document.head.appendChild(cartCountryStyle);
    enhanceFilterMarkup();
    repairAccountFields();
    enhanceAccountTabs();
    enhanceHeaderMarkup();
    enhanceNavigationSubmenus();
    enhanceMiniCartMarkup();
    enhanceWishlistDialogs();
    enhanceCountrySelector();
    enhanceSupportingMarkup();
    enhanceFooterAccordions();
    enhanceProductTabs();
    enhanceProductInformationDialog();
    enhanceRecentlyViewed();
    syncFilterDialog();
    syncMobileMenuDialog();
    syncCartAndCountryDialogs();
    syncWishlistDialog();
    syncRecentlyViewed();
    syncProductInformationDialog();
    initializeSizeGuideDialog();
    syncRecommendationSlides();
    syncHeroSlides();
    ensureStatusRegion();

    var bodyObserver = new MutationObserver(syncFilterDialog);
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    var filter = document.querySelector('.filter-main');
    if (filter) {
      var filterObserver = new MutationObserver(enhanceFilterMarkup);
      filterObserver.observe(filter, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    var mobileMenu = document.querySelector('.toggol-menu');
    if (mobileMenu) {
      var mobileMenuObserver = new MutationObserver(function syncMobileNavigation() {
        syncMobileMenuDialog();
        enhanceNavigationSubmenus();
      });
      mobileMenuObserver.observe(mobileMenu, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }

    var miniCart = document.querySelector('.min-cart');
    if (miniCart) {
      var miniCartObserver = new MutationObserver(function syncMiniCartAfterMutation() {
        syncCartAndCountryDialogs();
        enhanceMiniCartItems(document);
      });
      miniCartObserver.observe(miniCart, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    var recommendations = document.querySelectorAll('[data-mdv-recs]');
    Array.prototype.forEach.call(recommendations, function observeRecommendations(recommendation) {
      var recommendationObserver = new MutationObserver(function syncRecommendationsAfterMutation() {
        window.requestAnimationFrame(syncRecommendationSlides);
      });
      recommendationObserver.observe(recommendation, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    });
    Array.prototype.forEach.call(document.querySelectorAll('.sale-slider-deta'), function observeHero(hero) {
      var heroObserver = new MutationObserver(function syncHeroAfterMutation() {
        window.requestAnimationFrame(syncHeroSlides);
      });
      heroObserver.observe(hero, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    });

    Array.prototype.forEach.call(document.querySelectorAll('.wishlist-popup'), function observeWishlist(popup) {
      var wishlistObserver = new MutationObserver(syncWishlistDialog);
      wishlistObserver.observe(popup, { attributes: true, attributeFilter: ['class'] });
    });

    var countrySelector = document.querySelector('.country-selector.custom-country-selector');
    if (countrySelector) {
      var countryObserver = new MutationObserver(syncCartAndCountryDialogs);
      countryObserver.observe(countrySelector, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }

    var recentlyViewed = document.querySelector('.recently-viewed-products');
    if (recentlyViewed) {
      var recentlyViewedObserver = new MutationObserver(syncRecentlyViewed);
      recentlyViewedObserver.observe(recentlyViewed, { attributes: true, attributeFilter: ['class'] });
    }

    Array.prototype.forEach.call(document.querySelectorAll('.product_tabs_new'), function observeProductTabs(tabs) {
      var productTabsObserver = new MutationObserver(enhanceProductTabs);
      productTabsObserver.observe(tabs, { attributes: true, subtree: true, attributeFilter: ['class', 'style'] });
    });

    var productInformationDialog = document.querySelector('.product_tabs_popup');
    if (productInformationDialog) {
      var productInformationObserver = new MutationObserver(syncProductInformationDialog);
      productInformationObserver.observe(productInformationDialog, { attributes: true, subtree: true, attributeFilter: ['class', 'style'] });
    }

    var supportingObserver = new MutationObserver(enhanceSupportingMarkup);
    supportingObserver.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('resize', function syncResponsiveAccessibility() {
      syncRecommendationSlides();
      syncHeroSlides();
      enhanceFooterAccordions();
      syncProductInformationDialog();
    });
    document.addEventListener('transitionend', function syncRecommendationsAfterTransition(event) {
      if (!event.target || !event.target.closest) return;
      if (event.target.closest('[data-mdv-recs]')) syncRecommendationSlides();
      if (event.target.closest('.sale-slider-deta')) syncHeroSlides();
    });

    if (window.jQuery) {
      window.jQuery(document)
        .off('ajaxComplete.mdvAccessibilityCart')
        .on('ajaxComplete.mdvAccessibilityCart', function handleCartRefresh(event, xhr, settings) {
          if (!settings || !settings.url || settings.url.indexOf('view=min-cart') === -1) return;
          window.setTimeout(completeCartAction, 50);
        });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
}());
